import { type RecipeNames } from '@farmersdog/constants';
import { Picture, Text, Underline } from '@farmersdog/corgi-x';
import { isDiySignup } from '@farmersdog/lead-browser-storage';

import { RecipeBowlPicture } from '../../../images/RecipeBowlPicture';
import { VetRecommendedPlanPill } from '../../../VetRecommendedPlanPill';

import diyJp2 from './assets/diy.jp2';
import diyPng from './assets/diy.png';
import diyWebP from './assets/diy.webp';
import styles from './Hero.module.css';
import { Recipes } from './Recipes/Recipes';

const DIY_RESOURCES = [diyWebP, diyJp2, diyPng];
export interface HeroArgs {
  firstName: string | null;
  dogName: string;
  vetName: string;
  freshRecipeNames?: string[];
  diyRecipeDisplayNames?: string[];
  isMobile: boolean;
}

export function Hero({
  dogName,
  vetName,
  firstName,
  diyRecipeDisplayNames,
  freshRecipeNames,
  isMobile,
}: HeroArgs) {
  const isDiy = isDiySignup();

  return (
    <div className={styles.hero}>
      <VetRecommendedPlanPill isMobile={isMobile} />
      <Text variant={isMobile ? 'heading-28' : 'heading-40'} bold as="h1">
        Hi {firstName}! Here is {dogName}’s plan from{' '}
        <Underline>{vetName}</Underline>.
      </Text>

      <Recipes
        isDiy={isDiy}
        isMobile={isMobile}
        diyRecipeDisplayNames={diyRecipeDisplayNames}
        freshRecipeNames={freshRecipeNames}
      />

      {isDiy ? (
        <div className={styles.diyImage}>
          <Picture sources={DIY_RESOURCES} alt="nutrient mix packets" />
        </div>
      ) : (
        <ul className={styles.freshRecipeList}>
          {freshRecipeNames
            ?.slice(0, isMobile ? 1 : freshRecipeNames.length)
            ?.map(recipe => (
              <li key={recipe} className={styles.freshRecipeListItem}>
                <RecipeBowlPicture
                  recipeName={recipe as RecipeNames}
                  className={styles.recipeImage}
                />
              </li>
            ))}
        </ul>
      )}
    </div>
  );
}
